module.exports = __webpack_public_path__ + "static/media/pausee.330dcf9d.png";